import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  InjectionToken,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, map, Observable, of } from 'rxjs';
import { CmsApiService, FileResponse } from '../../services/cms-api.service';
import { ResponsiveService } from '../../shared/services/responsive.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

export const COOKIEBOT_KEY = new InjectionToken<string>('COOKIEBOT_KEY');

@Component({
  selector: 'app-cookie-settings',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './cookie-settings.component.html',
  styleUrl: './cookie-settings.component.css'
})
export class CookieSettingsComponent implements OnInit {
  public markdownContent = signal<string | undefined>(``);
  public htmlStr: string = '';
  public isMobile$: Observable<boolean> = this.responsiveService.isMobile$;
  public loading = false;

  constructor(
    private cmsApiService: CmsApiService,
    private destroyRef: DestroyRef,
    private responsiveService: ResponsiveService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.cmsApiService
      .getLegalDocument('cookie-policy')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((markdownContent: FileResponse) => {
          return markdownContent.data;
        }),
        catchError((error) => {
          console.error('Error fetching cookie policy:', error);
          this.markdownContent.set(undefined);
          return of(null); // Use `of(null)` to complete the observable
        })
      )
      .subscribe((markdownContent) => {
        this.loading = false;
        if (markdownContent) {
          console.error('markdownContent');
          this.readBlobAsText(markdownContent);
        }
      });
  }

  readBlobAsText(blob: Blob) {
    const reader = new FileReader();
    reader.onload = () => {
      this.markdownContent.set(reader.result as string); // Set the read content to a string
      this.htmlStr = reader.result as string;
    };
    reader.readAsText(blob); // Read the blob as text
  }
}
